import React from 'react';
import { SwitchPropsType } from 'src/domains/common/components/switch/switch.types';
import { cn } from 'src/domains/common/components/utils';
import { observer } from 'src/utils/mobx-react';

export const Switch = observer(
    'Switch',
    ({
        label,
        labelPosition = 'right',
        dataTest,
        dataTestSpan,
        checked,
        onChange,
        disabled,
        className,
        ...props
    }: SwitchPropsType): JSX.Element => {
        return (
            <label className='relative flex items-center cursor-pointer'>
                {labelPosition === 'left' && <span className='mr-2 text-sm'>{label}</span>}

                <input
                    type='checkbox'
                    className='sr-only'
                    checked={checked}
                    onChange={onChange}
                    disabled={disabled}
                    data-test={dataTest}
                    {...props}
                />
                <span
                    className={cn(
                        'block w-9 h-5 bg-input border-solid border-2 border-transparent rounded-full transition-colors relative',
                        checked === true && 'bg-primary',
                        disabled === true && 'opacity-50 cursor-not-allowed',
                        className
                    )}
                    data-test={dataTestSpan}
                >
                    <span
                        className={cn(
                            'absolute left-0.5 top-1/2 size-4 -translate-y-1/2 bg-background border border-gray-300 rounded-full transition-transform',
                            checked === true && 'translate-x-[13px]',
                            disabled === true && 'opacity-50'
                        )}
                    />
                </span>
                {labelPosition === 'right' && <span className='ml-2 text-sm'>{label}</span>}
            </label>
        );
    }
);
